import { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { ROUTES } from '../utils/constants';
import api from '../services/api';
import SuccessModal from '../components/common/SuccessModal';

const ResetPasswordPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token');
  
  const [formData, setFormData] = useState({
    password: '',
    confirmPassword: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [showSuccess, setShowSuccess] = useState(false);

  if (!token) {
    return (
      <div className="relative z-10 py-20 bg-bg min-h-screen flex items-center">
        <div className="container mx-auto px-4">
          <div className="max-w-[500px] mx-auto">
            <div className="bg-white rounded-3xl shadow-custom-lg p-10 text-center">
              <div className="w-20 h-20 bg-red-100 rounded-full flex items-center justify-center text-red-600 text-4xl mx-auto mb-6">
                <i className="fas fa-times"></i>
              </div>
              <h1 className="text-2xl font-black text-text mb-4">رابط غير صالح</h1>
              <p className="text-text3 mb-6">
                الرابط غير صالح أو منتهي الصلاحية. يرجى طلب رابط جديد.
              </p>
              <Link
                to="/forgot-password"
                className="inline-block px-8 py-4 bg-primary text-white font-bold rounded-xl hover:bg-primary-dark transition-all"
              >
                طلب رابط جديد
              </Link>
            </div>
          </div>
        </div>
      </div>
    );
  }

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (formData.password !== formData.confirmPassword) {
      setError('كلمة المرور غير متطابقة');
      return;
    }

    if (formData.password.length < 6) {
      setError('كلمة المرور يجب أن تكون 6 أحرف على الأقل');
      return;
    }

    setLoading(true);

    try {
      await api.resetPassword(token, formData.password);
      setShowSuccess(true);
      setTimeout(() => {
        navigate(ROUTES.LOGIN);
      }, 2000);
    } catch (err) {
      setError(err.message || 'حدث خطأ. الرابط قد يكون منتهي الصلاحية.');
      setLoading(false);
    }
  };

  return (
    <div className="relative z-10 py-20 bg-bg min-h-screen flex items-center">
      {showSuccess && (
        <SuccessModal message="تم تغيير كلمة المرور بنجاح!" />
      )}
      <div className="container mx-auto px-4">
        <div className="max-w-[500px] mx-auto">
          <div className="bg-white rounded-3xl shadow-custom-lg p-10">
            <div className="text-center mb-8">
              <div className="w-20 h-20 bg-gradient-to-br from-primary to-secondary rounded-2xl flex items-center justify-center text-white text-3xl mx-auto mb-6">
                <i className="fas fa-lock"></i>
              </div>
              <h1 className="text-3xl font-black text-text mb-2">إعادة تعيين كلمة المرور</h1>
              <p className="text-text3">دخل كلمة المرور الجديدة</p>
            </div>

            {error && (
              <div className="mb-6 p-4 bg-red-50 border-2 border-red-200 rounded-xl text-red-600 text-center">
                {error}
              </div>
            )}

            <form onSubmit={handleSubmit} className="space-y-5">
              <div>
                <label className="block text-text font-bold mb-2">كلمة المرور الجديدة</label>
                <input
                  type="password"
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  required
                  className="w-full px-5 py-4 bg-bg border-2 border-border rounded-xl text-text outline-none focus:border-primary transition-colors"
                  placeholder="••••••••"
                />
              </div>

              <div>
                <label className="block text-text font-bold mb-2">تأكيد كلمة المرور</label>
                <input
                  type="password"
                  name="confirmPassword"
                  value={formData.confirmPassword}
                  onChange={handleChange}
                  required
                  className="w-full px-5 py-4 bg-bg border-2 border-border rounded-xl text-text outline-none focus:border-primary transition-colors"
                  placeholder="••••••••"
                />
              </div>

              <button
                type="submit"
                disabled={loading}
                className="w-full px-8 py-4 bg-primary text-white font-bold rounded-xl hover:bg-primary-dark transition-all shadow-custom hover:shadow-custom-lg disabled:opacity-50"
              >
                {loading ? 'جاري التحديث...' : 'تحديث كلمة المرور'}
              </button>
            </form>

            <div className="mt-6 text-center">
              <p className="text-text3">
                <Link to={ROUTES.LOGIN} className="text-primary font-bold hover:underline">
                  العودة لتسجيل الدخول
                </Link>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResetPasswordPage;
